export default function snackbar(state = false, action) {
  switch (action.type) {
    case "SNACKBARACTIVE":
      return action.snackbarData;

    default:
      return state;
  }
}
